import React from "react";
import exchangeIcon from "../../../styles/icons/transfer_icon.png"
import historyIcon from "../../../styles/icons/history_icon.png";
import profileIcon from "../../../styles/icons/profile_icon.png";
import newsIcon from "../../../styles/icons/news_icon.png";

import exchangeIconActive  from "../../../styles/icons/transfer_active_icon.png"
import historyIconActive  from "../../../styles/icons/history_active_icon.png";
import profileIconActive  from "../../../styles/icons/profile_active_icon.png";
import newsIconActive  from "../../../styles/icons/news_active_icon.png";

import { useTranslation } from "react-i18next";

const Navigation = ({ activeTab, setActiveTab }) => {
  const {t} = useTranslation("profile")

  const tabs = [
    { id: "exchange", label: t("EXCHANGE"), icon: exchangeIcon, iconActive: exchangeIconActive },
    { id: "history", label: t("HISTORY"), icon: historyIcon, iconActive: historyIconActive },
    { id: "news", label: t("NEWS"), icon: newsIcon, iconActive: newsIconActive },
    { id: "profile", label: t("PROFILE"), icon: profileIcon, iconActive: profileIconActive },
  ];

  return (
    <nav
      className="
        sticky bottom-0 left-0 right-0 
        bg-white border-t border-gray-200
        flex z-[998] shadow-[0_-2px_8px_rgba(0,0,0,0.1)]
        px-0 py-2
        w-full max-w-full
        lg:max-w-md lg:left-1/2 lg:transform lg:-translate-x-1/2
      "
      style={{
        paddingBottom: "max(8px, env(safe-area-inset-bottom))",
        paddingLeft: "max(0px, env(safe-area-inset-left))",
        paddingRight: "max(0px, env(safe-area-inset-right))",
        height: 'auto',
        minHeight: '60px'
      }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`
            flex-1 flex flex-col items-center justify-center
            text-xs transition-colors min-h-[48px]
            ${
              activeTab === tab.id
                ? "text-blue-500"
                : "text-gray-400 hover:text-gray-600"
            }
            px-2 py-1
          `}
        >
          <img
            src={activeTab === tab.id ? tab.iconActive : tab.icon}
            alt={tab.label}
            className="w-6 h-6 mb-1 flex-shrink-0"
          />
          <span className="leading-tight">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default Navigation;